import { useEffect, useRef } from 'react';

import { sendPageViewLog } from '@weblog';

export function usePageViewLog(log: Record<string, any> | null) {
  const sentLog = useRef(false);

  useEffect(() => {
    if (!log) {
      return;
    }

    if (!sentLog.current) {
      try {
        sendPageViewLog(log);
      } catch (e) {
        // ignore
      }

      sentLog.current = true;
    }
  }, [log]);
}
